import type { NotifSection } from "../store/notificationStore";
import logger from "./logger";

/** Files live in public/sounds; firebase-messaging-sw.js relays the section name. */
const SOUND_URLS: Record<NotifSection, string> = {
  pairChat: "/sounds/noti_water_drop.mp3",
  streetChat: "/sounds/noti_sheep.mp3",
};

const players: Partial<Record<NotifSection, HTMLAudioElement>> = {};

/**
 * Plays the new-message sound for a chat section. Never throws: browsers
 * reject play() until the user has interacted with the page (autoplay policy),
 * and a missed chime must not break notification handling.
 */
export function playChatSound(section: NotifSection): void {
  try {
    let audio = players[section];
    if (!audio) {
      audio = new Audio(SOUND_URLS[section]);
      players[section] = audio;
    }
    audio.currentTime = 0;
    const result = audio.play();
    if (result && typeof result.catch === "function") {
      result.catch((e) => logger.debug("[Sound] play() rejected", e));
    }
  } catch (e) {
    logger.debug("[Sound] playback failed", e);
  }
}

export function isNotifSection(value: unknown): value is NotifSection {
  return value === "pairChat" || value === "streetChat";
}
